import { return_01, return_02, return_03, return_04, return_05 } from "../../_components/Imagepath";

export default {
  PurchaseReturnData: [
    {
      "id": 1,
      "product": "Lenovo 3rd Generation",
      "image": return_01,
      "price": "$7248.00",
      "quantitySold": 50,
      "quantityAvailable": 100,
      date:"20 Aug 2023"
    },
    {
      "id": 2,
      "product": "Nike Jordan",
      "image": return_02,
      "price": "$1350.00",
      "quantitySold": 70,
      "quantityAvailable": 140,
      date:"23 Aug 2023"
    },
    {
      "id": 3,
      "product": "Apple Series 5 Watch",
      "image": return_03,
      "price": "$700.00",
      "quantitySold": 30,
      "quantityAvailable": 200,
      date:"27 Aug 2023"
    },
    {
      "id": 4,
      "product": "Amazon Echo Dot",
      "image": return_04,
      "price": "$200.00",
      "quantitySold": 20,
      "quantityAvailable": 250,
      date:"29 Aug 2023"
    },
    {
      "id": 5,
      "product": "Lobar Handy",
      "image": return_05,
      "price": "$150.00",
      "quantitySold": 40,
      "quantityAvailable": 300,
      date:"30 Aug 2023"
    }
  ], 
};
